import { MailIcon } from "@heroicons/react/solid";
import React from "react";

export default function ModuleCard({ module }) {
  const { src, hoverSrc, status, name, descript } = module;
  const [showAIMail, setShowAIMail] = React.useState(false)
  const [thumb, setThumb] = React.useState(src)
  const handleMouseEnter = () => {
    setShowAIMail(true)
    setThumb(hoverSrc)
  }
  const handleMouseLeave = () => {
    setShowAIMail(false)
    setThumb(src)
  }
  return (
    <div
      className="relative group cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img src={thumb} alt="thumb" className="w-full h-56" />
      <span
        className={`absolute right-2 top-2 text-white px-3 py-0.5 rounded-full
          ${status === "PRODUCTIZED" ? "bg-sprimary-600" : "bg-ssecondary-600"}
        `}
      >
        {status}
      </span>
      <h3
        className={`${status === 'PRODUCTIZED' ? 'group-hover:bg-sprimary-600' : 'group-hover:bg-ssecondary-600'}
       group-hover:text-white flex justify-between items-center py-1
      `}
      >
        <span className="text-lg group-hover:pl-2">{name}</span>
        {
          showAIMail && <div className="flex">
            {
              status === 'PRODUCTIZED' && <span
                className="border-2 border-white rounded-full bg-gray-600 text-white text-xs w-5 h-5 flex justify-center items-center mr-2"
              >
                Ai
              </span>
            }
            <MailIcon className="text-white h-5 mr-2" />
          </div>
        }

      </h3>
      <p className="leading-1">{descript}</p>
    </div>
  );
}
